export default __webpack_public_path__ + "static/media/santa-cap-right.f173ba59.svg";